import {useTranslation} from "react-i18next";

function TableHeader({columns}) {
    const {t} = useTranslation()

    return (
        <div className="table-header">
            {columns?.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="table-header--cell"
                        >
                            {t(`table.${item}`)}
                        </div>
                    )
            })}
        </div>
    )
}

export default TableHeader